import { Hostable } from '../../services/hostable';

export abstract class BlockContentComponent<T> extends Hostable<T> {}
